export const DEVICE_CONDITIONS: string[] = ['NEW', 'PRE_OWNED', 'REFURBISHED'];